import React, { useEffect,useCallback, useState } from 'react'
import AppSidebar from '../../components/AppSidebar'
import AppHeader from '../../components/AppHeader'
import PageHeader from '../../components/PageHeader';
import UsersService from '../../services/UsersService';
import { toast, ToastContainer } from 'react-toastify';
import Pagination from '../../components/Pagination';
import CommonTable from '../../components/CommonTable';
import Filters from '../../components/Filters';
import UseDebounce from '../../hooks/UseDebounce';
import { PageLimit } from '../../utils/ConstantUtils';
import { DebounceDelay } from '../../utils/ConstantUtils'
import ChangePassword from '../../modals/ChangePassword';
import { useForm } from 'react-hook-form';
import AuthService from '../../services/AuthService';


  const ListUser = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const pageLimit = PageLimit || 20;
    const [itemsPerPage, setPageLimit] = useState(pageLimit);
    const offset = (currentPage - 1) * itemsPerPage;
    const [appliedFilters, setAppliedFilters] = useState({});
    const debouncedSearchTerm = UseDebounce(searchTerm, DebounceDelay || 100);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const { formState: { errors }, handleSubmit, register } = useForm();
    
  const columns = [
    { Header: '', accessor: '', sample: 'Sample Data' },
    { Header: '#', accessor: 'id', sample: 'Sample Data' },
    { Header: 'Company', accessor: 'company.name', sample: 'Sample Data' },
    { Header: 'Name', accessor: 'name', sample: 'Sample Data' },
    { Header: 'Email', accessor: 'email', sample: 'Sample Data' },
    { Header: 'Phone No', accessor: 'phone', sample: 'Sample Data' },
    { Header: 'Status', accessor: 'status', sample: 'Sample Data' },
    { Header: 'Reset Password', accessor: 'change_password', sample: 'Sample Data' },
  ];

  const fetchData = useCallback(async() => {
    try{
      const response = await UsersService.getAll({
        page: currentPage,
        limit: itemsPerPage,
        search: debouncedSearchTerm,
        offset: offset || 0,
        filters: appliedFilters,
      });
      setRows(response?.data?.data?.users);
      setTotalPages(response?.data?.data?.meta?.totalPages);
      setCurrentPage(response?.data?.data?.meta?.currentPage);
    }catch(error){
      console.error('Error fetching users:', error);
      toast.error(error?.response?.data?.message || error?.message);
    }finally{
      setLoading(false);
    }
  },[currentPage, itemsPerPage, debouncedSearchTerm, offset, appliedFilters]);

  useEffect(() => { 
    fetchData();
  }, [appliedFilters,fetchData]);

  const handleShowResetPasswordModal = (userId) => {
    setSelectedUserId(userId);
    setShowResetPasswordModal(true);
  }
  
  const handleCloseResetPasswordModal = () => {
    setShowResetPasswordModal(false);
  };

  const onSubmitResetPassword = async (data) => {
    if (!selectedUserId) return;

    try {
      const { password } = data;
      const requestBody = {
        data: {
          password: password,
          userId: selectedUserId,
        },
      };

      const response = await UsersService.ChangePassword(requestBody);

      if (response.status === 200) {
        toast.success("Password reset successfully");
        handleCloseResetPasswordModal();
      } else {
        toast.error(response.message || "An error occurred while resetting the password.");
      }
    } catch (error) {
      toast.error(error?.message || "An error occurred.");
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleItemsPerPageChange = (e) => {
    setCurrentPage(1);
    setPageLimit(e.target.value);
  };

  const handleFilterSubmit = (newFilters) => {
    setAppliedFilters(newFilters);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'active':
        return 'badge bg-success'; 
      case 'inactive':
        return 'badge bg-danger'; 
      default:
        return 'badge bg-dark'; 
    }
  };

   const filterFields = [
    { name: 'company', placeholder: 'Company Name' },
    { name: 'name', placeholder: 'Name' },
    { name: 'email', placeholder: 'Email' },
    { name: 'phone', placeholder: 'Phone No' },
    { name: 'status', placeholder: 'Status' },
  ];

  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader title = 'Users' />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <PageHeader title="Users" button_label="Create" link_to="create" className="btn btn-sm btn-primary" />
              <div className="tab-content">
                <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
                  <div className="card">
                    <div className="card-header">
                      <div className="row align-items-center">
                        <div className="col">
                          <form>
                            <div className="input-group input-group-flush input-group-merge input-group-reverse">
                              <input
                                className="form-control list-search"
                                type="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={handleSearchChange}
                              />
                              <span className="input-group-text">
                                <i className="fe fe-search" />
                              </span>
                            </div>
                          </form>
                        </div>
                        <div className="col-auto me-n3">
                          <form>
                            <select
                              className="form-select form-select-sm form-control-flush"
                              value={itemsPerPage}
                              onChange={handleItemsPerPageChange}
                            >
                               <option value="20">20 per page</option>
                              <option value="40">40 per page</option>
                              <option value="60">60 per page</option>
                              <option value="100">100 per page</option>
                            </select>
                          </form>
                        </div>
                        <div className="col-auto">
                           {/* Use the Filters component here */}
                           <Filters filterFields={filterFields} onApplyFilters={handleFilterSubmit} />
                        </div>
                      </div>
                    </div>
                   
                    {/* Common Table component*/}
                    <CommonTable
                      loading={loading}
                      rows={rows}
                      columns={columns}
                      selectedRows={selectedRows}
                      setSelectedRows={setSelectedRows}
                      basePath="user"
                      showLimitedOptions={true}
                      offset={offset}
                      getStatusBadgeClass = {getStatusBadgeClass}
                      showCheckboxes = {false}
                      handleShowResetPasswordModal = {handleShowResetPasswordModal}
                    />
                    <ToastContainer />

                  {/* Change Password Modal */}
                    <ChangePassword
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmitResetPassword}
                      show = {showResetPasswordModal}
                      handleClose = {handleCloseResetPasswordModal}
                      register={register}
                      errors={errors}
                    />
                    {/* Pagination Component */}
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ListUser;
